import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { colors } from "../../data/tokens";
import { displayDateOnly } from "../../util/dateOnly";

type UserListDateColumnProps = {
  record: any;
};

// Todas as datas do sócio empilhadas, uma por linha, com rótulos curtos.
// A data usada na ordenação atual (localStorage "dateField", gravada pelo
// painel de filtros) continua em negrito.
// `timestamp: true` marca os campos que guardam data + hora reais (criação,
// atualização) — esses seguem no fuso local. Os demais são datas civis, sem
// hora, e precisam ser lidos em UTC para não recuar um dia.
const DATE_FIELDS: Array<{ key: string; label: string; timestamp?: boolean }> = [
  { key: "remissionDate", label: "Remido" },
  { key: "collectiveRemissionDate", label: "Colet. remido" },
  { key: "collectiveDate", label: "Coletivo" },
  { key: "contributionDate", label: "Contribuinte" },
  { key: "aspirantDate", label: "Aspirante" },
  { key: "effectiveDate", label: "Efetivo" },
  { key: "admissionDate", label: "Admissão" },
  { key: "licenseDate", label: "Licenciado" },
  { key: "cancellationDate", label: "Cancelado" },
  { key: "birthDate", label: "Nascimento" },
  { key: "deceasedDate", label: "Falecimento" },
  { key: "seniorDate", label: "Sênior" },
  { key: "createdAt", label: "Criado", timestamp: true },
  { key: "updatedAt", label: "Atualizado", timestamp: true },
];

export const UserListDateColumn = (props: UserListDateColumnProps) => {
  const { record } = props;
  const activeField = localStorage.getItem("dateField");
  const entries = DATE_FIELDS.filter((f) => record && record[f.key]);
  if (entries.length === 0) return null;
  return (
    <Box
      sx={{
        display: "grid",
        // Uma data por linha, empilhadas
        gridTemplateColumns: "auto",
        rowGap: 0.25,
        justifyContent: "start",
      }}
    >
      {entries.map((f) => {
        const bold = activeField === f.key;
        const valor = f.timestamp
          ? moment(record[f.key]).format("DD/MM/YYYY")
          : displayDateOnly(record[f.key]);
        return (
          <Typography
            key={f.key}
            sx={{
              fontSize: 12,
              whiteSpace: "nowrap",
              // Rótulo mais leve, data em destaque: o que se lê é a data
              color: bold ? colors.primaryDark : colors.textSecondary,
              fontWeight: bold ? 700 : 400,
            }}
          >
            {f.label}:{" "}
            <Box
              component="span"
              sx={{
                color: bold ? colors.primaryDark : colors.textStrong,
                fontWeight: bold ? 700 : 500,
              }}
            >
              {valor}
            </Box>
          </Typography>
        );
      })}
    </Box>
  );
};
